export const PACKAGE_TABS = ['Summary', 'Price sets'];
